import { subscriberIdApi } from '../../store';
import { formatSubscriberIdApiUrl } from '../../utils/formatApiUrl';
import { IAdditionalAccounts } from './types';

export const additionalAccountsApi = subscriberIdApi.injectEndpoints({
    endpoints: (builder) => ({
        getAccounts: builder.query<IAdditionalAccounts, string>({
            query: (subscriberId) => formatSubscriberIdApiUrl(subscriberId, 'additional-accounts'),
            transformResponse: response =>
                ({ ...(response || {}), actions: response?.actions ?? [] }),
        }),
    }),
});

export const {
    useGetAccountsQuery,
} = additionalAccountsApi;
